export const MenuItems = [
    {
        title: 'Experience',
        url: '/experience',
        cName: 'nav-links'
    },
    {
        title: 'Projects',
        url: '/projects',
        cName: 'nav-links'
    },
    {
        title: 'Passions',
        url: '/passions',
        cName: 'nav-links'
    },
    {
        title: 'Contact',
        url: 'Contact',
        cName: 'nav-links-mobile'
    }
]